export default __webpack_public_path__ + "static/media/II-2020.7e7652a7.pdf";